export interface Category {
  id: string;
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export interface VarietyShow {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  description: string;
  episodes: number;
  rating: number;
  isHot: boolean;
  isNew: boolean;
  tags: string[];
  host: string;
  platform: string;
  updateDay: string;
}

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  author: string;
  publishDate: string;
  readCount: number;
  tags: string[];
  relatedShowIds: string[];
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    slug: 'gaoxiao-zongyi',
    name: '搞笑综艺',
    icon: 'ri-emotion-laugh-line',
    description: '最搞笑的综艺节目，让你笑到停不下来',
  },
  {
    id: 'cat-2',
    slug: 'zhenrenxiu',
    name: '真人秀',
    icon: 'ri-user-star-line',
    description: '明星真人秀，揭秘明星真实生活',
  },
  {
    id: 'cat-3',
    slug: 'tuokouxiu',
    name: '脱口秀',
    icon: 'ri-mic-line',
    description: '幽默脱口秀，犀利吐槽引爆笑点',
  },
  {
    id: 'cat-4',
    slug: 'yinyue-zongyi',
    name: '音乐综艺',
    icon: 'ri-music-line',
    description: '音乐竞技与表演，声音的盛宴',
  },
  {
    id: 'cat-5',
    slug: 'huyou-zongyi',
    name: '户外综艺',
    icon: 'ri-landscape-line',
    description: '户外冒险挑战，热血与激情的碰撞',
  },
  {
    id: 'cat-6',
    slug: 'shenghuo-zongyi',
    name: '生活综艺',
    icon: 'ri-home-heart-line',
    description: '慢生活综艺，治愈你的日常',
  },
  {
    id: 'cat-7',
    slug: 'jingji-zongyi',
    name: '竞技综艺',
    icon: 'ri-trophy-line',
    description: '激烈比拼，智慧与体力的较量',
  },
  {
    id: 'cat-8',
    slug: 'tanhua-zongyi',
    name: '谈话综艺',
    icon: 'ri-chat-smile-2-line',
    description: '深度访谈，聆听内心的故事',
  },
];

export const varietyShows: VarietyShow[] = [
  {
    id: 'show-1',
    title: '笑傲江湖第十季',
    category: '搞笑综艺',
    categorySlug: 'gaoxiao-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20Chinese%20comedy%20variety%20show%20stage%20with%20colorful%20lights%20and%20comedians%20performing%2C%20warm%20spotlight%2C%20cheerful%20atmosphere%2C%20vibrant%20stage%20design%2C%20professional%20photography%2C%20clean%20composition%20with%20soft%20background%20bokeh&width=800&height=450&seq=show-1&orientation=landscape',
    description: '《笑傲江湖》第十季重磅回归！全新赛制，更多喜剧大咖加盟，带你领略中国顶尖喜剧人的爆笑对决。',
    episodes: 12,
    rating: 9.2,
    isHot: true,
    isNew: true,
    tags: ['喜剧', '竞技', '搞笑'],
    host: '郭德纲',
    platform: '香蕉影视独播',
    updateDay: '每周五',
  },
  {
    id: 'show-2',
    title: '奔跑吧兄弟第十二季',
    category: '真人秀',
    categorySlug: 'zhenrenxiu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20Chinese%20reality%20show%20celebrities%20running%20in%20a%20sunny%20park%2C%20dynamic%20action%20shots%2C%20bright%20daylight%2C%20energetic%20vibe%2C%20sports%20competition%20theme%2C%20professional%20cinematic%20photography%20with%20motion%20blur&width=800&height=450&seq=show-2&orientation=landscape',
    description: '兄弟团再次集结，全新一季跑男带你环游中国！极限挑战、烧脑推理、温情时刻，一网打尽。',
    episodes: 14,
    rating: 8.9,
    isHot: true,
    isNew: false,
    tags: ['户外', '竞技', '明星'],
    host: '李晨',
    platform: '香蕉影视独播',
    updateDay: '每周六',
  },
  {
    id: 'show-3',
    title: '脱口秀大会第七季',
    category: '脱口秀',
    categorySlug: 'tuokouxiu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Standup%20comedy%20stage%20with%20single%20microphone%20and%20spotlight%2C%20dark%20audience%20background%2C%20modern%20Chinese%20comedy%20club%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20live%20performance%20photography%2C%20warm%20and%20intimate%20mood&width=800&height=450&seq=show-3&orientation=landscape',
    description: '新一季脱口秀大会重磅来袭！新老脱口秀演员同台竞技，犀利吐槽社会热点，爆笑不断。',
    episodes: 10,
    rating: 9.0,
    isHot: true,
    isNew: true,
    tags: ['脱口秀', '幽默', '竞技'],
    host: '李诞',
    platform: '香蕉影视独播',
    updateDay: '每周三',
  },
  {
    id: 'show-4',
    title: '中国好声音2026',
    category: '音乐综艺',
    categorySlug: 'yinyue-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20competition%20stage%20with%20rotating%20chairs%20and%20colorful%20stage%20lighting%2C%20singers%20performing%2C%20grand%20concert%20atmosphere%2C%20professional%20music%20show%20production%2C%20dramatic%20spotlight%20effect%2C%20warm%20and%20energetic%20ambiance&width=800&height=450&seq=show-4&orientation=landscape',
    description: '经典音乐选秀节目全新升级！四位重量级导师坐镇，寻找中国最美声音，精彩对决不容错过。',
    episodes: 15,
    rating: 8.7,
    isHot: false,
    isNew: true,
    tags: ['音乐', '选秀', '竞技'],
    host: '华少',
    platform: '香蕉影视独播',
    updateDay: '每周五',
  },
  {
    id: 'show-5',
    title: '极限挑战第十季',
    category: '户外综艺',
    categorySlug: 'huyou-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20challenge%20show%20with%20celebrities%20doing%20extreme%20tasks%20in%20urban%20city%2C%20action%20packed%20scene%2C%20bright%20sunny%20weather%2C%20dynamic%20teamwork%2C%20professional%20broadcast%20production%20quality%2C%20energetic%20atmosphere&width=800&height=450&seq=show-5&orientation=landscape',
    description: '极限男人帮再度出发！城市冒险、脑力对决，每一期都是全新的惊喜与挑战。',
    episodes: 12,
    rating: 9.1,
    isHot: true,
    isNew: false,
    tags: ['户外', '冒险', '挑战'],
    host: '黄磊',
    platform: '香蕉影视独播',
    updateDay: '每周日',
  },
  {
    id: 'show-6',
    title: '向往的生活第八季',
    category: '生活综艺',
    categorySlug: 'shenghuo-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Rustic%20countryside%20farmhouse%20with%20celebrities%20cooking%20and%20farming%2C%20warm%20sunset%20light%2C%20peaceful%20rural%20scenery%2C%20cozy%20lifestyle%20show%20photography%2C%20natural%20greenery%20and%20wooden%20house%2C%20heartwarming%20atmosphere&width=800&height=450&seq=show-6&orientation=landscape',
    description: '回归田园，享受慢生活。蘑菇屋迎来新一季嘉宾，一起种地、做饭、聊天，治愈你的心灵。',
    episodes: 14,
    rating: 8.8,
    isHot: false,
    isNew: false,
    tags: ['田园', '生活', '治愈'],
    host: '何炅',
    platform: '香蕉影视独播',
    updateDay: '每周五',
  },
  {
    id: 'show-7',
    title: '最强大脑第十一季',
    category: '竞技综艺',
    categorySlug: 'jingji-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20brain%20competition%20stage%20with%20holographic%20displays%20and%20digital%20screens%2C%20intense%20concentration%20atmosphere%2C%20modern%20studio%20design%2C%20blue%20and%20white%20technology%20theme%2C%20professional%20TV%20production%20photography&width=800&height=450&seq=show-7&orientation=landscape',
    description: '全球顶尖脑力选手汇聚一堂，超乎想象的智力对决，见证人类大脑的无限可能。',
    episodes: 10,
    rating: 9.3,
    isHot: false,
    isNew: false,
    tags: ['智力', '竞技', '科学'],
    host: '蒋昌建',
    platform: '香蕉影视独播',
    updateDay: '每周四',
  },
  {
    id: 'show-8',
    title: '圆桌派第八季',
    category: '谈话综艺',
    categorySlug: 'tanhua-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20round%20table%20discussion%20setting%20with%20tea%20and%20books%2C%20warm%20intellectual%20atmosphere%2C%20cultural%20Chinese%20talk%20show%20setup%2C%20soft%20natural%20lighting%20from%20window%2C%20cozy%20study%20room%20decor%2C%20sophisticated%20vibe&width=800&height=450&seq=show-8&orientation=landscape',
    description: '窦文涛携新老朋友，围坐圆桌，畅聊文化、社会、人生。有深度的谈话，有温度的交流。',
    episodes: 24,
    rating: 9.4,
    isHot: false,
    isNew: true,
    tags: ['谈话', '文化', '深度'],
    host: '窦文涛',
    platform: '香蕉影视独播',
    updateDay: '每周一',
  },
  {
    id: 'show-9',
    title: '哈哈哈哈哈第五季',
    category: '搞笑综艺',
    categorySlug: 'gaoxiao-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20road%20trip%20comedy%20variety%20show%20with%20group%20of%20friends%20laughing%20in%20a%20car%2C%20travel%20adventure%20theme%2C%20bright%20daylight%20scenery%2C%20funny%20and%20joyful%20expressions%2C%20casual%20documentary%20style%20photography%2C%20warm%20vibrant%20colors&width=800&height=450&seq=show-9&orientation=landscape',
    description: '五哈兄弟再次集结，公路旅行爆笑不断！一路欢声笑语，意想不到的旅途奇遇。',
    episodes: 12,
    rating: 8.6,
    isHot: true,
    isNew: false,
    tags: ['旅行', '搞笑', '真人秀'],
    host: '邓超',
    platform: '香蕉影视独播',
    updateDay: '每周六',
  },
  {
    id: 'show-10',
    title: '歌手2026',
    category: '音乐综艺',
    categorySlug: 'yinyue-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Grand%20music%20concert%20stage%20with%20singer%20under%20dramatic%20spotlight%2C%20large%20orchestra%20in%20background%2C%20theatrical%20performance%20atmosphere%2C%20professional%20live%20music%20show%20production%2C%20elegant%20and%20powerful%20stage%20design%2C%20warm%20golden%20lighting&width=800&height=450&seq=show-10&orientation=landscape',
    description: '华语乐坛顶级歌手同台竞技，震撼人心的LIVE现场，每一首歌都是视听盛宴。',
    episodes: 13,
    rating: 9.5,
    isHot: true,
    isNew: true,
    tags: ['音乐', '竞技', 'LIVE'],
    host: '何炅',
    platform: '香蕉影视独播',
    updateDay: '每周五',
  },
  {
    id: 'show-11',
    title: '密室大逃脱第六季',
    category: '真人秀',
    categorySlug: 'zhenrenxiu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20escape%20room%20setting%20with%20dim%20atmospheric%20lighting%2C%20puzzles%20and%20clues%20scattered%2C%20team%20of%20players%20solving%20mysteries%2C%20suspenseful%20thriller%20atmosphere%2C%20cinematic%20horror%20game%20show%20photography%2C%20dramatic%20shadows&width=800&height=450&seq=show-11&orientation=landscape',
    description: '全新升级的密室挑战！更刺激的机关、更烧脑的谜题，明星玩家能否成功逃脱？',
    episodes: 12,
    rating: 8.5,
    isHot: false,
    isNew: true,
    tags: ['密室', '推理', '悬疑'],
    host: '杨幂',
    platform: '香蕉影视独播',
    updateDay: '每周四',
  },
  {
    id: 'show-12',
    title: '这！就是街舞第七季',
    category: '竞技综艺',
    categorySlug: 'jingji-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Street%20dance%20battle%20competition%20stage%20with%20dancers%20performing%20dynamic%20moves%2C%20urban%20graffiti%20background%2C%20colorful%20neon%20lighting%2C%20hiphop%20culture%20vibe%2C%20energetic%20professional%20dance%20show%20photography%2C%20dramatic%20action%20shots&width=800&height=450&seq=show-12&orientation=landscape',
    description: '全球顶尖舞者集结，炸裂的街舞对决！四大战队激烈PK，谁能问鼎冠军宝座？',
    episodes: 12,
    rating: 9.0,
    isHot: true,
    isNew: false,
    tags: ['街舞', '竞技', '潮流'],
    host: '王一博',
    platform: '香蕉影视独播',
    updateDay: '每周六',
  },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '《歌手2026》首播收视率破纪录，华语乐坛再掀音乐狂潮',
    excerpt: '万众瞩目的《歌手2026》首期节目收视率突破3.5%，创下今年综艺节目最高纪录。多位实力唱将的精彩表现引发全网热议。',
    content: '在万众期待中，《歌手2026》终于迎来了首播。本季节目汇聚了华语乐坛最具实力的歌手阵容，从流行到摇滚、从民谣到R&B，多元化的音乐风格让观众大饱耳福。首期节目中，七位首发歌手纷纷拿出自己的代表作，精彩的LIVE表演让现场观众起立鼓掌。据收视数据显示，首期节目收视率高达3.5%，网络播放量突破2亿次，微博话题阅读量超过50亿，创下今年综艺节目多项纪录。',
    category: '音乐综艺',
    categorySlug: 'yinyue-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Grand%20Chinese%20music%20award%20ceremony%20with%20singers%20on%20stage%2C%20golden%20trophy%2C%20dramatic%20spotlight%2C%20cheering%20audience%2C%20professional%20event%20photography%2C%20warm%20and%20celebratory%20atmosphere%2C%20elegant%20stage%20design&width=1200&height=600&seq=article-1&orientation=landscape',
    author: '娱乐编辑小王',
    publishDate: '2026-07-28',
    readCount: 125800,
    tags: ['歌手2026', '音乐综艺', '收视率'],
    relatedShowIds: ['show-10', 'show-4'],
  },
  {
    id: 'article-2',
    title: '《笑傲江湖》第十季爆笑回归，郭德纲携新老笑匠同台飙戏',
    excerpt: '暌违两年的《笑傲江湖》第十季正式回归，郭德纲继续担任主持人，全新赛制升级，更多喜剧新人崭露头角。',
    content: '作为国内最具影响力的喜剧竞技节目，《笑傲江湖》第十季在观众的期待中正式回归。本季节目在赛制上进行了全面升级，引入了"踢馆赛"和"观众投票"等新环节，让节目更具看点和悬念。主持人郭德纲表示："这一季的笑匠们水平非常高，每期节目都有让人捧腹大笑的精彩表演。"节目首期就邀请了来自全国各地的16组喜剧人同台竞技，涵盖相声、小品、脱口秀、默剧等多种喜剧形式。',
    category: '搞笑综艺',
    categorySlug: 'gaoxiao-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20stage%20with%20red%20curtains%20and%20performers%20in%20traditional%20Chinese%20costume%2C%20bright%20theatrical%20lighting%2C%20festive%20atmosphere%2C%20professional%20stage%20photography%2C%20warm%20and%20joyful%20colors&width=1200&height=600&seq=article-2&orientation=landscape',
    author: '综艺评论员小李',
    publishDate: '2026-07-25',
    readCount: 98700,
    tags: ['笑傲江湖', '郭德纲', '喜剧综艺'],
    relatedShowIds: ['show-1'],
  },
  {
    id: 'article-3',
    title: '《脱口秀大会》第七季阵容曝光，李诞携新生代笑匠强势来袭',
    excerpt: '《脱口秀大会》第七季选手阵容正式公布，既有老将回归也有新秀亮相，李诞、王建国等熟面孔悉数登场。',
    content: '随着《脱口秀大会》第七季的临近，节目组正式公布了本季的选手阵容。除了李诞、王建国、庞博等脱口秀老将外，本季还迎来了多位新生代脱口秀演员，其中不乏在短视频平台拥有百万粉丝的网络红人。节目制片人透露，本季将更加注重"真实表达"，鼓励选手对社会热点话题进行幽默解读。脱口秀作为一种新兴的喜剧形式，近年来在国内发展迅猛，《脱口秀大会》无疑是推动这一文化现象的重要力量。',
    category: '脱口秀',
    categorySlug: 'tuokouxiu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20standup%20comedy%20club%20stage%20with%20brick%20wall%20background%20and%20single%20microphone%2C%20warm%20intimate%20lighting%2C%20casual%20performance%20venue%2C%20professional%20comedy%20show%20photography%2C%20cozy%20atmosphere&width=1200&height=600&seq=article-3&orientation=landscape',
    author: '娱乐编辑小张',
    publishDate: '2026-07-22',
    readCount: 85600,
    tags: ['脱口秀大会', '李诞', '喜剧'],
    relatedShowIds: ['show-3'],
  },
  {
    id: 'article-4',
    title: '《奔跑吧》第十二季首站三亚录制，兄弟团沙滩挑战爆笑连连',
    excerpt: '《奔跑吧》第十二季首期节目在海南三亚完成录制，兄弟团在碧海蓝天下展开了一系列令人捧腹的沙滩游戏。',
    content: '《奔跑吧》第十二季首期节目选在了风景如画的海南三亚进行录制。在碧海蓝天的映衬下，跑男团成员们展开了一场别开生面的沙滩运动会。从沙滩排球到水上拔河，从椰子保龄球到沙雕大赛，各种脑洞大开的游戏让现场笑声不断。据悉，本季节目将走遍中国多个特色城市，每期都会融入当地的文化元素，让观众在欢笑中领略祖国的大好河山。新加入的两位常驻嘉宾也为节目注入了新鲜活力。',
    category: '真人秀',
    categorySlug: 'zhenrenxiu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20tropical%20beach%20with%20group%20playing%20beach%20games%2C%20sunny%20blue%20sky%2C%20crystal%20clear%20water%2C%20fun%20outdoor%20activity%2C%20professional%20travel%20photography%2C%20vibrant%20and%20energetic%20colors&width=1200&height=600&seq=article-4&orientation=landscape',
    author: '旅游娱乐记者小陈',
    publishDate: '2026-07-20',
    readCount: 112300,
    tags: ['奔跑吧', '真人秀', '三亚'],
    relatedShowIds: ['show-2'],
  },
  {
    id: 'article-5',
    title: '《向往的生活》蘑菇屋新址曝光，依山傍水田园风光美如画',
    excerpt: '《向往的生活》第八季拍摄地正式曝光，新一季蘑菇屋坐落在浙江安吉的竹林深处，风景绝美如同世外桃源。',
    content: '备受期待的《向往的生活》第八季拍摄地终于揭开了神秘面纱。新一季的蘑菇屋选在了浙江安吉的一片竹海之中，依山傍水、环境清幽。从曝光的照片来看，蘑菇屋采用原木建造，四周环绕着翠绿的竹林和潺潺的溪流，宛如一幅中国水墨画。节目导演表示，选择安吉是因为这里完美契合了"向往的生活"的理念——远离城市喧嚣，回归自然本真。本季嘉宾阵容也相当豪华，多位演艺圈大咖将作为飞行嘉宾参与录制。',
    category: '生活综艺',
    categorySlug: 'shenghuo-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20bamboo%20forest%20with%20traditional%20wooden%20house%20in%20Chinese%20countryside%2C%20morning%20mist%2C%20peaceful%20rural%20landscape%2C%20green%20nature%20scenery%2C%20professional%20landscape%20photography%2C%20serene%20and%20healing%20atmosphere&width=1200&height=600&seq=article-5&orientation=landscape',
    author: '文化记者小刘',
    publishDate: '2026-07-18',
    readCount: 76400,
    tags: ['向往的生活', '田园', '安吉'],
    relatedShowIds: ['show-6'],
  },
  {
    id: 'article-6',
    title: '《极限挑战》十周年特别企划，回顾十年经典名场面',
    excerpt: '《极限挑战》迎来十周年，节目组特别策划了"十年经典回顾"特辑，盘点这十年来的高光时刻和感人瞬间。',
    content: '十年光阴，弹指一挥间。《极限挑战》从2016年首播至今，已经陪伴观众走过了整整十个年头。为庆祝这一里程碑时刻，节目组精心策划了"十年经典回顾"特别企划。从第一季的"金条争夺战"到后来的"重庆火锅挑战"，从"男人帮"的兄弟情谊到每一期的爆笑名场面，这十年留下了太多难忘的回忆。本季节目将邀请多位经典嘉宾回归，与观众一起重温那些年的感动与欢笑。',
    category: '户外综艺',
    categorySlug: 'huyou-zongyi',
    imageUrl: 'https://readdy.ai/api/search-image?query=Retro%20style%20Chinese%20variety%20show%20anniversary%20celebration%20with%20golden%20number%2010%20and%20confetti%2C%20group%20photo%20of%20celebrities%2C%20festive%20atmosphere%2C%20professional%20event%20photography%2C%20warm%20nostalgic%20golden%20lighting&width=1200&height=600&seq=article-6&orientation=landscape',
    author: '综艺编辑小赵',
    publishDate: '2026-07-15',
    readCount: 134600,
    tags: ['极限挑战', '十周年', '经典回顾'],
    relatedShowIds: ['show-5'],
  },
];

export const faqItems = [
  {
    question: '香蕉影视需要付费观看吗？',
    answer: '不需要！香蕉影视所有综艺节目均免费观看，无需会员、无需付费，打开即可畅享高清综艺内容。我们承诺：全集免费，永不收费。',
  },
  {
    question: '为什么选择香蕉影视观看综艺？',
    answer: '香蕉影视专注于综艺娱乐内容，拥有最全面的综艺节目资源库。我们的播放器采用先进的视频编码技术，支持高清画质和流畅播放，即使在移动网络环境下也能秒开不缓冲。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '香蕉影视支持全平台观看，包括电脑、平板和手机。无论您使用Windows、Mac、iOS还是Android设备，都可以流畅访问我们的网站，随时随地享受精彩综艺。',
  },
  {
    question: '综艺节目多久更新一次？',
    answer: '我们与各大综艺节目保持同步更新，热门综艺播出后24小时内即可在香蕉影视观看。每周都有最新综艺上线，让您永远不错过任何精彩内容。',
  },
  {
    question: '如何搜索想看的综艺节目？',
    answer: '您可以通过首页的分类导航找到感兴趣的综艺类型，也可以使用搜索功能直接搜索节目名称。我们的分类涵盖搞笑综艺、真人秀、脱口秀、音乐综艺等八大类型，方便快速定位。',
  },
  {
    question: '播放卡顿怎么办？',
    answer: '香蕉影视采用CDN加速技术，全国多节点部署，确保流畅播放。如遇卡顿，建议检查网络连接或尝试切换画质。我们提供自适应码率功能，会根据您的网速自动调整最佳清晰度。',
  },
];